import API from "./lib/api";

export const getAllBuyGetDiscountOffersApi = async (restaurant_id, query = "") => {
  try {
    const { data } = await API.get(
      `restaurant/${restaurant_id}/buy-and-get-discount-offers?${query}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleBuyGetDiscountOfferApi = async (id) => {
  try {
    const { data } = await API.get(
      `restaurant/buy-and-get-discount-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const addBuyGetDiscountOfferApi = async (offerData) => {
  try {
    const { data } = await API.post(
      `restaurant/buy-and-get-discount-offers`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const editBuyGetDiscountOfferApi = async (offerData, id) => {
  try {
    const { data } = await API.put(
      `restaurant/buy-and-get-discount-offers/${id}`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteBuyGetDiscountOfferApi = async (id) => {
  try {
    const { data } = await API.delete(
      `restaurant/buy-and-get-discount-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleBuyGetDiscountOfferStatusApi = async (id) => {
  try {
    const { data } = await API.put(
      `restaurant/buy-and-get-discount-offers/${id}/toggle-status`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
